import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import { UnknownErrorMessage } from "@/common/components/UnknownErrorMessage";
import { MaintenaceWorkflowData } from "@/features/privateCompanies/types/maintenance/workflows/maintenanceWorkflows.type";
import { useMemo } from "react";
import { maintenanceForwardingsDirectiveEntryKlasses } from "../../../constants/maintenanceForwardingsDirectiveEntryKlasses.constant";
import { useMaintenanceForwarding } from "../../../features/forwardings/hooks/useMaintenanceForwarding";
import { MaintenanceForwardingsDirectiveEntryKlass } from "../../../features/forwardings/types/maintenanceForwardingsDirectiveEntryKlasses.type";
import { ForwardingTabContext } from "../../../hooks/forwardings/useForwardingTabContext";
import MaintenanceWorkflowForwardingShowLoading from "./MaintenanceWorkflowForwardingShowLoading";

interface MaintenanceWorkflowForwardingShowProps {
  workflow: MaintenaceWorkflowData | undefined;
  forwardingId: string;
  directiveEntryKlass: MaintenanceForwardingsDirectiveEntryKlass;
}

const MaintenanceWorkflowForwardingShow = ({
  workflow,
  forwardingId,
  directiveEntryKlass,
}: MaintenanceWorkflowForwardingShowProps) => {
  const {
    data: forwarding,
    isPending: forwardingIsPending,
    error: forwardingError = {} as any,
    refetch: refetchForwarding,
    dataUpdatedAt: forwardingUpdatedAt,
  } = useMaintenanceForwarding(forwardingId);

  const ForwardingStateComponent = useMemo(() => {
    const maintenaceDirectiveEntryData = maintenanceForwardingsDirectiveEntryKlasses[directiveEntryKlass];

    if (!maintenaceDirectiveEntryData) {
      return false;
    }

    const directiveEntryStatusData = forwarding?.status && maintenaceDirectiveEntryData.status[forwarding.status];

    if (!directiveEntryStatusData) {
      return false;
    }

    return directiveEntryStatusData.component || false;
  }, [directiveEntryKlass, forwarding?.status]);

  if (forwardingIsPending) {
    return <MaintenanceWorkflowForwardingShowLoading />
  }

  return (
    <ErrorMessageWrapper
      className="flex-1"
      statusCode={forwardingError?.status}
      refetchFunction={refetchForwarding}
    >
      {forwarding && ForwardingStateComponent && (
        <ForwardingTabContext.Provider
          value={{
            workflow,
            forwarding,
            forwardingUpdatedAt,
            directiveEntryKlass,
          }}
        >
          <div className="flex-1 overflow-auto flex flex-col gap-4">
            <ForwardingStateComponent />
          </div>
        </ForwardingTabContext.Provider>
      )}

      {(!forwarding || !ForwardingStateComponent) && (
        <UnknownErrorMessage className="flex-1" />
      )}
    </ErrorMessageWrapper>
  );
}

export default MaintenanceWorkflowForwardingShow;
